import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { FormModule } from './form/form.module'
import { TablesModule } from './tables/tables.module'
import { LayoutModule } from './layout/layout.module'
import { MaterialModule } from '../material/material.module'
import { BillingSharedModule } from './billing/billing.module'

import { TooltipComponent } from './tooltip/tooltip.component'
import { CardComponent, CardContentComponent, CardTitleComponent } from './card.component'
import { ProgressBarComponent } from './progress-bar.component'
import { AppStoreAndGoogleBadgesComponent } from 'src/app/shared/components/app-store-and-google-badges/app-store-and-google-badges.component'
import { SpinnerComponent } from './spinner.component'
import { NetworkStatusComponent } from './network-status/network-status.component'

@NgModule({
  declarations: [
    TooltipComponent,
    CardComponent,
    CardTitleComponent,
    CardContentComponent,
    ProgressBarComponent,
    AppStoreAndGoogleBadgesComponent,
    SpinnerComponent,
    NetworkStatusComponent,
  ],
  exports: [
    TooltipComponent,
    CardComponent,
    CardTitleComponent,
    CardContentComponent,
    SpinnerComponent,
    ProgressBarComponent,
    AppStoreAndGoogleBadgesComponent,
    TablesModule,
    FormModule,
    LayoutModule,
    BillingSharedModule,
    NetworkStatusComponent,
  ],
  imports: [CommonModule, MaterialModule],
})
export class ComponentsModule {}
